import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArchive = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" d="M0 2h16v3H0zM5 7H1v8h14V7h-4v2H5z" />
  </svg>
);
export default SvgArchive;
